
import { useMediaQuery } from "@/hooks/use-media-query";

/**
 * Un hook personnalisé pour détecter si l'appareil est mobile
 * @returns {boolean} - true si l'écran est de taille mobile, false sinon
 */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 768px)");
}
